import { AnyItemVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/item"

class UIStore {
  currentItem: AnyItemVM;
  currentSubItem: AnyItemVM;
  multipleItems: Record<string, boolean>;
  clipboard: AnyItemVM[];
  editorStatus: number;
  callStack: string[];

  constructor(
    currentItem: AnyItemVM = {} as AnyItemVM,
    currentSubItem: AnyItemVM = {} as AnyItemVM,
    multipleItems: Record<string, boolean> = {},
    clipboard: AnyItemVM[] = [],
    editorStatus = 0,
    callStack: string[] = []
  ) {
    this.currentItem = currentItem
    this.currentSubItem = currentSubItem
    this.multipleItems = multipleItems
    this.clipboard = clipboard
    this.editorStatus = editorStatus
    this.callStack = callStack ?? []
  }
}
export { UIStore }
